import Dashboard     from "@/views/application/Dashboard.vue"
import Denuncias     from "@/views/application/Denuncias.vue"
import Blacklist     from "@/views/application/Blacklist.vue"
import Denuncia      from "@/views/application/Denuncia.vue"
import Den_details   from "@/views/application/Den_details.vue"
import Gravacao      from "@/views/application/Gravacao.vue"
import Relatorio     from "@/views/application/Relatorio.vue"
import Cadastro      from "@/views/application/Cadastro.vue"
import MonitorRamais from "@/views/application/Ramais.vue"
import Ramal         from "@/views/application/Ramal.vue"
import Emails        from "@/views/application/Emails.vue"
import Auditoria     from "@/views/application/Auditoria.vue"
import Configuracoes from "@/views/application/Configuracoes.vue"

import dsb_routes from "./Subroutes/Dashboard.js"
import cad_routes from "./Subroutes/Cadastro.js"
import cfg_routes from "./Subroutes/Configuracoes.js"
import rel_routes from "./Subroutes/Relatorio.js"

import middleware from 'vue-router-multiguard'
import Store 	  from '@/vuex/store.js'

const Admin_Middleware = (to, from, next) => {
	if (Store.state.user.type > 1 ) next()
	else next({ name: "dsb_Charts" })
}

const Super_Middleware = (to, from, next) => {
	if (Store.state.user.type > 1 ) next()
	else next({ name: "dsb_Charts" })
}

export default [
	{
		path: "/",
		redirect: { name: "dsb_Charts", params: { get: 'Graficos' } },
	},

	{
		name: "Dashboard",
		path: "Dashboard",
		component: Dashboard,
		props: true,
		children: dsb_routes
	},

	{
		name: "Denuncias",
		path: ":get",
		component: Denuncias,
		props: true,
	},

	{
		name: "Den_details",
		path: ":get/Detalhes/:denuncia_id",
		component: Den_details,
		props: true,
	},

	{
		name: "Denuncia",
		path: ":get/Historico/:denuncia_id",
		component: Denuncia,
		props: true,
		beforeEnter: middleware([Super_Middleware])
	},

	{
		name: "Gravacao",
		path: ":get/Historico/:gravacao",
		component: Gravacao,
		props: true,
		beforeEnter: middleware([Super_Middleware])
	},

	{
		name: "Blacklist",
		path: "Blacklist",
		component: Blacklist,
		beforeEnter: middleware([Super_Middleware])
	},

	{
		path: "Relatorio",
		component: Relatorio,
		props: true,
		children: rel_routes,
		beforeEnter: middleware([Admin_Middleware])
	},

	{
		name: "Cadastro",
		path: "Cadastro",
		component: Cadastro,
		props: true,
		children: cad_routes,
		beforeEnter: middleware([Admin_Middleware])
	},

	{
		name: "Monitor",
		path: "Monitor/Ramais",
		component: MonitorRamais,
		beforeEnter: middleware([Super_Middleware])
	},

	{
		name: "RamalView",
		path: "Monitor/Ramal/:get",
		component: Ramal,
		props: true,
		beforeEnter: middleware([Super_Middleware])
	},

	{
		name: "Emails",
		path: "Emails",
		component: Emails,
		beforeEnter: middleware([Admin_Middleware])
	},

	{
		name: "Auditoria",
		path: "Auditoria",
		component: Auditoria,
		beforeEnter: middleware([Super_Middleware])
	},

	{
		name: "Configuracoes",
		path: "Configuracoes",
		component: Configuracoes,
		props: true,
		children: cfg_routes,
		beforeEnter: middleware([Admin_Middleware])
	},
]